import React  from 'react'
export default () => (<em>- Empty -</em>)



// WEBPACK FOOTER //
// ../src/components/Tree/BasicEmptyNodeRenderer.js